import { render, staticRenderFns } from "./config-statistic.vue?vue&type=template&id=68855419"
import script from "./config-statistic.vue?vue&type=script&lang=js"
export * from "./config-statistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports